import { fetchGetStateByStateKey } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

import TopUpStatusMessage from './TopUpStatusMessage';
import messages from './TopUpStatusMessages.messages';
import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export const NotTopUpEligible = () => {
    const stateKey = useStateKey();

    const {
        data: customerStateRepsponse,
        isLoading,
        isError
    } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey })
    });

    if (isLoading || isError) return null;

    const companyName =
        customerStateRepsponse.data.application!.company!
            .registered_company_name;

    return (
        <TopUpStatusMessage
            heading={<FormattedMessage {...messages.notTopupEligilbeText} />}
            description={
                <>
                    <strong>{companyName}</strong>{' '}
                    <FormattedMessage
                        {...messages.notTopupEligilbeDescription}
                    />
                </>
            }
            ctaText={<FormattedMessage {...messages.notTopupEligilbeCTAText} />}
        />
    );
};
